/* eslint-disable tp/import-from-vue-composition-only */
import {
  ref,
  computed,
  inject,
  provide,
  reactive,
  watch,
  watchEffect,
  nextTick,
  onUpdated,
  onMounted,
  onUnmounted,
  onBeforeMount,
  onBeforeUnmount,
  onBeforeUpdate,
  onRenderTriggered,
  onRenderTracked,
  onScopeDispose,
  defineComponent,
  defineAsyncComponent,
  onErrorCaptured,
  createApp,
  mergeProps,
  h,
  toRef,
  toRefs,
  toRaw,
  markRaw,
  isRef,
  getCurrentInstance,
  readonly,
  shallowReadonly,
  Suspense,
  Fragment,
  Text,
  Comment,
  unref,
  shallowRef,
  shallowReactive,
  useAttrs,
  resolveComponent,
  useSlots,
  toValue,
  useTemplateRef,
  useId,
  effectScope,
  type DirectiveBinding,
  type AsyncComponentLoader,
  type VNode,
  type ComponentPublicInstance,
  type Plugin,
  type SetupContext,
  type PropType,
  type Reactive,
  type Ref,
  type ShallowRef,
  type TemplateRef,
  type ComputedRef,
  type WritableComputedRef,
  type UnwrapRef,
  type App,
  type Component,
  type AsyncComponentOptions,
  type DefineComponent as TpDefineComponent,
  type ComponentPropsOptions,
  type ComponentObjectPropsOptions,
  type DeepReadonly,
  type ExtractPropTypes,
  type MaybeRef,
  type Directive,
  type ObjectDirective,
  type DirectiveHook,
  type ToRef,
  type ToRefs,
  type MaybeRefOrGetter,
  type StyleValue,
  type WatchStopHandle,
  type EmitFn,
  type WatchHandle,
  type AllowedComponentProps,
  type VNodeProps,
  type ClassValue,
  type HTMLAttributes,
  type CSSProperties,
} from 'vue'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  useCssVar,
  useEventListener,
  onClickOutside,
  onKeyDown,
  useIntervalFn,
  createSharedComposable,
  useMousePressed,
  computedAsync,
  computedWithControl,
  useElementBounding,
  useDropZone,
  useMediaQuery,
  useMutationObserver,
  useResizeObserver,
  useIntersectionObserver,
  useLocalStorage as useLocalStorageVueuse,
  useVModel,
  watchDebounced,
  watchThrottled,
} from '@vueuse/core'

export function waitForAsyncRef<T>(targetRef: Ref<T>, cb: (arg: Exclude<T, undefined>) => void) {
  setTimeout(() => {
    const value = unref(targetRef)
    if (value === undefined) {
      waitForAsyncRef(targetRef, cb)
      return
    }

    cb(value as Exclude<T, undefined>)
  })
}

export function fromRefs<T extends ToRefs>(refObject: T): T extends ToRefs<infer R> ? R : never {
  return Object.entries(refObject).reduce((result, [key, value]) => {
    result[key] = unref(value)
    return result
  }, {} as any)
}

export {
  Suspense,
  Fragment,
  Text,
  Comment,
  computed,
  computedAsync,
  computedWithControl,
  createApp,
  defineAsyncComponent,
  defineComponent,
  getCurrentInstance,
  h,
  inject,
  isRef,
  mergeProps,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  onBeforeUpdate,
  onErrorCaptured,
  onMounted,
  onRenderTracked,
  onRenderTriggered,
  onScopeDispose,
  onUnmounted,
  onUpdated,
  provide,
  reactive,
  readonly,
  shallowReadonly,
  ref,
  toRef,
  toRefs,
  toRaw,
  markRaw,
  unref,
  watch,
  watchDebounced,
  watchThrottled,
  watchEffect,
  shallowRef,
  shallowReactive,
  useEventListener,
  useAttrs,
  onClickOutside,
  onKeyDown,
  useIntervalFn,
  resolveComponent,
  createSharedComposable,
  useMousePressed,
  useSlots,
  toValue,
  useTemplateRef,
  useElementBounding,
  useId,
  effectScope,
  useDropZone,
  useMediaQuery,
  useMutationObserver,
  useCssVar,
  useResizeObserver,
  useIntersectionObserver,
  useLocalStorageVueuse,
  useVModel,
  type App,
  type AsyncComponentLoader,
  type AsyncComponentOptions,
  type Component,
  type ComponentPropsOptions,
  type ComponentObjectPropsOptions,
  type ComponentPublicInstance,
  type ComputedRef,
  type DeepReadonly,
  type DirectiveBinding,
  type Plugin,
  type PropType,
  type Reactive,
  type Ref,
  type ShallowRef,
  type TemplateRef,
  type SetupContext,
  type TpDefineComponent,
  type UnwrapRef,
  type VNode,
  type WritableComputedRef,
  type ExtractPropTypes,
  type MaybeRef,
  type Directive,
  type ObjectDirective,
  type DirectiveHook,
  type ToRef,
  type ToRefs,
  type MaybeRefOrGetter,
  type StyleValue,
  type WatchStopHandle,
  type EmitFn,
  type WatchHandle,
  type AllowedComponentProps,
  type VNodeProps,
  type ClassValue,
  type HTMLAttributes,
  type CSSProperties,
}
